import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { searchFiles } from "../api/search.api";

export function useSearch(query: string) {
  const [debouncedQuery, setDebouncedQuery] = useState(query);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query), 300);
    return () => clearTimeout(timer);
  }, [query]);

  return useQuery({
    queryKey: ["search", debouncedQuery],
    queryFn: () => searchFiles({ q: debouncedQuery }),
    enabled: debouncedQuery.length >= 2,
  });
}
